module.exports = __webpack_public_path__ + "img/error-publish.ebd6b3c1.svg";